import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["accept"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["drop-zone", {'drop-zone--hover': _ctx.isHovering}]),
    title: "Click here to select a file",
    onDragover: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragOver && _ctx.onDragOver(...args)), ["prevent","stop"])),
    onDragleave: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args)), ["prevent","stop"])),
    onDrop: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args))),
    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openFileBrowser && _ctx.openFileBrowser(...args)))
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("input", {
      type: "file",
      accept: _ctx.accept,
      multiple: "",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPick && _ctx.onPick(...args))),
      ref: "file"
    }, null, 40, _hoisted_1)
  ], 34))
}